// src/store/DamStore/DamViewModelContextProvider.js
import React from "react";
var DamStore = React.createContext();
var DamStoreProvider = ({ children, viewModel }) => {
  return /* @__PURE__ */ React.createElement(DamStore.Provider, { value: viewModel }, children);
};
var useDamViewModel = () => React.useContext(DamStore);
var withDamViewModel = (Component) => (props) => {
  return /* @__PURE__ */ React.createElement(Component, { ...props, viewModel: useDamViewModel() });
};

// esbuild-scss-modules-plugin:./index.module.scss
var digest = "60a415282ba416034e60ff5cbf6a2f58c0d4eb559e2329df2088b9330ff80b66";
var classes = { "onDragEnter": "_onDragEnter_rqhjt_1", "dropToUpload": "_dropToUpload_rqhjt_13", "bounce": "_bounce_rqhjt_32" };
var css = `._onDragEnter_rqhjt_1 {
  max-height: 100%;
  position: absolute;
  top: 100px;
  left: 0;
  z-index: 999;
  border: 1px var(--bs-success) dashed;
  background: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;
}

._dropToUpload_rqhjt_13 {
  position: fixed;
  left: calc(50% + 124px);
  bottom: 0;
  transform: translate(-50%, -50%);
  z-index: 1000;
}
._dropToUpload_rqhjt_13 p {
  background: var(--bs-white);
  color: var(--bs-black);
  min-width: 200px;
  text-align: center;
  min-height: 50px;
  padding: 10px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.3);
  margin-bottom: 0;
  border-radius: 5px;
}

._bounce_rqhjt_32 {
  animation: _bounce_rqhjt_32 2s infinite;
  -webkit-animation: _bounce_rqhjt_32 2s infinite;
  -moz-animation: _bounce_rqhjt_32 2s infinite;
  -o-animation: _bounce_rqhjt_32 2s infinite;
}

@keyframes _bounce_rqhjt_32 {
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-15px);
  }
  60% {
    transform: translateY(-5px);
  }
}`;
(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement("style");
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();
var index_module_default = classes;

// src/components/Dropzone/index.jsx
import React3 from "react";
import { useState } from "react";
import { useDropzone } from "react-dropzone";
import { useTranslation } from "react-i18next";

// src/svg/CloudUpload.jsx
import React2 from "react";
var CloudUpload = (props) => {
  return /* @__PURE__ */ React2.createElement(
    "svg",
    {
      ...props,
      width: "50",
      height: "50",
      viewBox: "0 0 50 50",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...props
    },
    /* @__PURE__ */ React2.createElement("rect", { x: "16.666", y: "18.75", width: "16.6667", height: "14.5833", fill: "#1AB394" }),
    /* @__PURE__ */ React2.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17.6246 15.1748C18.885 13.2239 20.7289 11.7205 22.8937 10.8788C25.0584 10.0372 27.4336 9.90011 29.6808 10.4872C31.928 11.0743 33.9326 12.3556 35.4091 14.1485C36.8856 15.9414 37.7586 18.1546 37.9037 20.4727C39.1101 20.4385 40.3113 20.6436 41.4379 21.0762C42.5646 21.5088 43.5944 22.1602 44.4679 22.993C45.3414 23.8258 46.0412 24.8233 46.5271 25.928C47.0129 27.0328 47.2751 28.2228 47.2985 29.4294C47.3219 30.6361 47.106 31.8354 46.6634 32.9581C46.2207 34.0808 45.56 35.1047 44.7194 35.9707C43.8789 36.8367 42.8751 37.5276 41.7661 38.0035C40.657 38.4795 39.4647 38.731 38.2579 38.7435H14.5829C12.8813 38.7419 11.1995 38.3778 9.64962 37.6754C8.09973 36.973 6.71726 35.9484 5.59428 34.67C4.4713 33.3915 3.63358 31.8885 3.1369 30.2609C2.64021 28.6334 2.49597 26.9187 2.71376 25.2311C2.93156 23.5435 3.5064 21.9216 4.40001 20.4735C5.29362 19.0254 6.48549 17.7843 7.89625 16.8328C9.30702 15.8814 10.9043 15.2414 12.5817 14.9555C14.2592 14.6696 15.9783 14.7443 17.6246 15.1748ZM31.4287 25.9769C31.3005 26.1373 31.1419 26.2709 30.962 26.37C30.7821 26.4691 30.5844 26.5318 30.3803 26.5544C30.1762 26.5771 29.9696 26.5592 29.7723 26.502C29.5751 26.4447 29.3911 26.3491 29.2308 26.2206L26.5621 24.0831V31.2498C26.5621 31.6642 26.3974 32.0616 26.1044 32.3546C25.8114 32.6477 25.414 32.8123 24.9996 32.8123C24.5852 32.8123 24.1877 32.6477 23.8947 32.3546C23.6017 32.0616 23.4371 31.6642 23.4371 31.2498V24.0831L20.7662 26.2185C20.6059 26.3467 20.4219 26.442 20.2247 26.4991C20.0276 26.5562 19.8211 26.5739 19.6171 26.5511C19.4131 26.5284 19.2156 26.4657 19.0358 26.3666C18.856 26.2676 18.6975 26.1341 18.5694 25.9737C18.4412 25.8134 18.3458 25.6294 18.2888 25.4322C18.2317 25.2351 18.214 25.0286 18.2368 24.8246C18.2595 24.6206 18.3222 24.4231 18.4212 24.2433C18.5203 24.0635 18.6538 23.905 18.8141 23.7769L24.0183 19.6164C24.2924 19.3939 24.634 19.2713 24.9871 19.2685H25.0037C25.3787 19.2685 25.7204 19.4019 25.9891 19.6227L31.185 23.7769C31.3454 23.9051 31.479 24.0637 31.5781 24.2436C31.6772 24.4235 31.7399 24.6211 31.7625 24.8253C31.7852 25.0294 31.7674 25.236 31.7101 25.4333C31.6528 25.6305 31.5572 25.8166 31.4287 25.9769Z",
        fill: "white"
      }
    )
  );
};
var CloudUpload_default = CloudUpload;

// src/components/Dropzone/index.jsx
var Dropzone = ({
  children,
  noClick,
  createAssets,
  className,
  isBtn = true,
  noDrag = true,
  accept = "*"
}) => {
  const [onDrag, setOnDrag] = useState(false);
  const { t } = useTranslation();
  const { getRootProps, getInputProps } = useDropzone({
    accept,
    noClick,
    noDrag,
    // maxFiles: 1,
    multiple: true,
    onDragEnter: () => {
      setOnDrag(true);
    },
    onDragLeave: () => {
      setOnDrag(false);
    },
    onDrop: (acceptedFiles) => {
      setOnDrag(false);
      createAssets(acceptedFiles);
    }
  });
  return /* @__PURE__ */ React3.createElement(
    "div",
    {
      className: `
        ${!isBtn ? `position-absolute h-100 w-100 top-0 start-0 ${onDrag ? "zindex-3" : "zindex-1"}` : ""}
      `
    },
    /* @__PURE__ */ React3.createElement("div", { className: `${className ?? "w-100 h-100"} ${onDrag ? "" : "position-relative"}` }, /* @__PURE__ */ React3.createElement("span", { className: `${onDrag ? index_module_default.onDragEnter : ""} pe-none` }), /* @__PURE__ */ React3.createElement("div", { ...getRootProps(), className: "cursor-auto w-100 h-100 outline-none" }, /* @__PURE__ */ React3.createElement(
      "input",
      {
        ...getInputProps(),
        className: "position-absolute start-0 top-0 bottom-0 end-0 cursor-auto outline-none"
      }
    ), children), onDrag ? /* @__PURE__ */ React3.createElement(
      "div",
      {
        className: `d-flex flex-column align-items-center pe-none text-center ${index_module_default.dropToUpload}`
      },
      /* @__PURE__ */ React3.createElement(CloudUpload_default, { className: `fa-bounce ${index_module_default.bounce}` }),
      /* @__PURE__ */ React3.createElement("button", { className: `m-0 btn zindex-3 shadow-none px-4 btn-success text-white` }, t("txt_drop_to_upload"))
    ) : null)
  );
};
var Dropzone_default = Dropzone;

export {
  DamStoreProvider,
  useDamViewModel,
  withDamViewModel,
  index_module_default,
  Dropzone_default
};
/*
 * @copyright   Copyright (C) 2022 AesirX. All rights reserved.
 * @license     GNU General Public License version 3, see LICENSE.
 */
